import classNames from 'classnames';
import { shortDate } from '../../utils/dateUtils';
import './StatusItem.scss';
import { prefixClass } from 'lib/utils';
import { Tooltip, Whisper } from 'rsuite';
import { RequestStatus } from '../../RequestItem/type';
import { useAuthContext } from 'context/useAuthContext';
import { HoneAbilityActions, HoneAbilitySubjects } from '@hone-automation/common';
import { QueueLabelMap } from '../../utils/askRequestUtils';

export type StatusItemProps = {
  userName: string;
  status: RequestStatus;
  showDate?: boolean;
  date?: string;
};

const StatusItem = (props: StatusItemProps) => {
  const { status, date, userName, showDate = false } = props;
  const { currentLocationAbility } = useAuthContext();
  const canManageQueue = currentLocationAbility.can(HoneAbilityActions.manage, HoneAbilitySubjects.Queue);

  const STATUS_VALUES_CLIENT = {
    created: QueueLabelMap.FOR_ME,
    inProgress: QueueLabelMap.KITCHEN_SYNC,
    resolved: QueueLabelMap.CLOSED,
  };

  const STATUS_VALUES_ADMIN = {
    created: QueueLabelMap.FOR_ME,
    inProgress: QueueLabelMap.FOR_CLIENTS,
    resolved: QueueLabelMap.CLOSED,
  };

  const showDateVal = shortDate(date);
  const statusToApply = canManageQueue ? STATUS_VALUES_ADMIN[status] : STATUS_VALUES_CLIENT[status];
  const userNameToApply = userName || 'KS accountant';
  const tooltipTitle = statusToApply + ' by ' + userNameToApply + (showDateVal ? ' on ' + showDateVal : '');
  const prefix = prefixClass('q-status-item');
  if (!statusToApply) return null;

  return (
    <Whisper placement="top" trigger="hover" speaker={<Tooltip>{tooltipTitle}</Tooltip>}>
      <div data-testid="status" className={classNames(prefix(), { [`status_${status.toLowerCase()}`]: true })}>
        <div data-testid="status-container" className={prefix('status')}>
          {statusToApply}
        </div>
        {showDate && (
          <div data-testid="date-container" className={prefix('date')}>
            {showDateVal}
          </div>
        )}
      </div>
    </Whisper>
  );
};

export default StatusItem;
